import { MarketData } from "react-ts-tradingview-widgets";

const TvMarketData = () => (
  <MarketData colorTheme="dark" isTransparent={true}  width={"100%"} ></MarketData>
);


export default TvMarketData
